import { render, staticRenderFns } from "./UserAccess.vue?vue&type=template&id=60895b09&scoped=true&"
import script from "./UserAccess.vue?vue&type=script&lang=js&"
export * from "./UserAccess.vue?vue&type=script&lang=js&"
import style0 from "./UserAccess.vue?vue&type=style&index=0&id=60895b09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60895b09",
  null
  
)

export default component.exports